import MuiTooltip, {TooltipProps as MuiTooltipProps} from '@mui/material/Tooltip'

import './tooltip.scss'

export const Tooltip: React.FC<MuiTooltipProps> = ({
  children,
  classes,
  ...rest
}) => {
  return (
    <MuiTooltip
      classes={{popper: 'override-tooltip', ...classes}}
      arrow
      disableInteractive
      {...rest}
    >
      {children}
    </MuiTooltip>
  )
}
